"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ailano": {
    "aea0454a": [{
      "hkey": "737316cf",
      "slug": "ailano",
      "name": "Ailano",
      "primary": true,
      "skipSearch": false
    }],
    "cerquete-grotta-di-croscina": [{
      "hkey": "737316cf",
      "slug": "ailano",
      "name": "Ailano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad189e99": [{
      "hkey": "737316cf",
      "slug": "ailano",
      "name": "Ailano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-sabelluccio": [{
      "hkey": "737316cf",
      "slug": "ailano",
      "name": "Ailano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;